var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-loader",class:{ 'init-loading': _vm.isInit }},[_c('div',{staticClass:"text-loader__container"},_vm._l((_vm.text),function(char,idx){return _c('span',{key:idx,style:(`--i:${idx + 1}`)},[_vm._v(_vm._s(char))])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }